// extracted by mini-css-extract-plugin
export default {"cusBtn":"styles-scoped__cusBtn--WeKB_"};